import { createFileRoute, redirect } from "@tanstack/react-router";
import { HokageMigrationTemplate } from "~/features/hokageMigration/HokageMigrationTemplate";
import { resolveHokageMigrationVisible } from "~/lib/hokageMigration";

export const Route = createFileRoute("/_authenticated/hokage-migration/")({
  beforeLoad: async () => {
    if (!(await resolveHokageMigrationVisible()))
      throw redirect({ to: "/my-page" });
  },
  component: HokageMigrationTemplate,
});
